// Backwards compatibility wrapper for MediaGallery
// ImageGallery now supports both images and videos
import MediaGallery from './MediaGallery'

export default MediaGallery
